import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';

// Sanctioned full-page auth-bootstrap wait (999.2130, brand Loading &
// Busy-State Standard): session state is unknowable client-side, so a
// skeleton cannot match the destination. Brand treatment: thin gold
// indeterminate bar + polite status text in an aria-busy region — never a
// bare text div.
export default function AuthBootstrapScreen({ message = 'Loading…' }) {
  return (
    <Box sx={{ maxWidth: 360, mx: 'auto', pt: '20vh', px: 3, textAlign: 'center' }}>
      <Box aria-busy="true">
        <LinearProgress
          color="secondary"
          aria-label={message}
          sx={(theme) => ({
            height: 4,
            borderRadius: '2px',
            mb: 2,
            bgcolor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : theme.palette.divider,
          })}
        />
      </Box>
      <Typography role="status" color="text.secondary">{message}</Typography>
    </Box>
  );
}
